<template>
  <div class="question-frame">
    <Background :background="background"/>
    <Person :person="person" mode="background"/>
    <div class="content">
      <div class="question-row">
        <Question
          :data="data.question"
          :bottomBar="bottomBars.question"
          :questionIndex="questionIndex"
          :backgroundStore="backgroundStore"
          :personStore="personStore"
          @changeBottomBar="changeBottomBar"
          @focusCreateAnswer="focusCreateAnswer"
          @deleteQuestion="deleteQuestion"
        />
        <div class="person-box">
          <Person :person="person" mode="normal"/>
        </div>
      </div>
      <div class="answers-row">
        <Answer
          :ref="answer.id"
          v-for="(answer, index) in data.answers"
          :key="answer.id"
          :data="answer"
          :bottomBar="bottomBarAnswer(index)"
          :answerIndex="index"
          :questions="questions"
          @changeBottomBar="changeBottomBar"
          @deleteAnswer="deleteAnswer"
          @goQuestion="goQuestion"
          @addQuestion="addQuestion"
        />
        <CreateAnswer
          ref="createAnswer"
          v-if="data.answers.length < 4"
          :answers="data.answers"
          @createAnswer="createAnswer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Background from '@/components/EditTree/Background'
import Person from '@/components/EditTree/Person'
import Question from '@/components/EditTree/Question'
import Answer from '@/components/EditTree/Answer'
import CreateAnswer from '@/components/EditTree/CreateAnswer'

import uniqid from 'uniqid'

export default {
  name: 'QuestionFrame',
  props: {
    data: Object,
    bottomBars: Object,
    questionIndex: Number,
    backgroundStore: Array,
    personStore: Array,
    questions: Array,
    answers: Array
  },
  components: {
    Background,
    Person,
    Question,
    Answer,
    CreateAnswer
  },
  methods: {
    changeBottomBar(payload) {
      this.$emit('changeBottomBar', payload);
    },
    bottomBarAnswer(index) {
      switch(index) {
        case 0: return this.bottomBars.answer_0;
        case 1: return this.bottomBars.answer_1;
        case 2: return this.bottomBars.answer_2;
        case 3: return this.bottomBars.answer_3;
      }
    },
    deleteAnswer({ answerIndex, answerId }) {
      this.data.question.answers.splice(answerIndex, 1);
      let index = this.answers.findIndex(answer => answer.id == answerId);
      this.answers.splice(index, 1);
    },
    createAnswer(text) {
      let lastAnswer = this.data.answers[this.data.answers.length - 1];
      let selectedVoice = { name: 'Google UK English Female', lang: 'en-GB' };
      if(lastAnswer) {
        selectedVoice = lastAnswer.selectedVoice;
      }
      let newAnswer = {
        id: uniqid(),
        text,
        hint: '',
        next: null,
        audioData: null,
        audioType: 'bot',
        recordingTime: 0,
        selectedVoice,
        recordDisable: false,
        feedback: false,
        feedbackStatus: 'info',
        feedbackMessage: ''
      }
      this.answers.push(newAnswer);
      this.data.question.answers.push(newAnswer.id);
    },
    focusCreateAnswer() {
      if(this.data.answers.length < 4) {
        this.$refs.createAnswer.$el.querySelector('textarea').focus();
      }
    },
    goQuestion(payload) {
      this.$emit('goQuestion', payload);
    },
    addQuestion(answerId) {
      let id = uniqid();
      let newQuestion = {
        id,
        text: '',
        audioData: null,
        answers: [],
        audioType: 'bot',
        recordingTime: 0,
        background: this.data.question.background,
        person: this.data.question.person,
        selectedVoice: this.data.question.selectedVoice
      };
      this.$refs[answerId][0].setNext(id);
      this.questions.push(newQuestion);
      setTimeout(() => {
        this.$emit('goQuestion', id);
      }, 10);
    },
    deleteQuestion(questionId) {
      this.$emit('deleteQuestion', questionId);
    }
  },
  computed: {
    background() {
      if(this.data.question.background.type == 'upload') {
        return { type: 'upload', data: this.data.externalBackground.data }
      } else {
        return this.data.question.background;
      }
    },
    person() {
      if(this.data.question.person.type == 'upload') {
        return { type: 'upload', data: this.data.externalPerson.data }
      } else {
        return this.data.question.person;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-frame {
  width: 100%;
  height: auto;
  min-height: 35rem;
  margin-top: 2rem;
  border: 2px solid rgba(255, 255, 255, 0.123);
  position: relative;
  border-radius: 0.2rem;

  .content {
    width: 100%;
    height: auto;
    min-height: 35rem;
    z-index: 1;
    display: flex;

    @media (max-width: 1000px) {
      flex-direction: column;
    }

    .question-row {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 1.5rem;
      @media (max-width: 1000px) {
        align-items: flex-start;
      }
      @media (max-width: 600px) {
        align-items: center;
      }

      .person-box {
        width: auto;
        height: auto;
        margin-top: auto;
        display: flex;

        @media (max-width: 1000px) {
          display: none;
        }
      }
    }

    .answers-row {
      height: auto;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 1.5rem;
      @media (max-width: 1000px) {
        align-items: flex-end;
        margin-top: 1.5rem;
      }
      @media (max-width: 600px) {
        align-items: center;
      }
    }
  }
}
</style>